import { useContext, useEffect, useState } from 'react';

import { useNavigate, useParams } from 'react-router';
import * as Yup from 'yup';

import { Form, MultiSelect, Text } from '../../../Components/Form';
import Loading from '../../../Components/Loading/Loading';
import TitleBar from '../../../Components/TitleBar/TitleBar';
import { useApi } from '../../../Hooks/Api';
import { useToast } from '../../../Hooks/Toast';
import Master from '../../../Layouts/Master';
import { serverErrorHandler } from '../../../Utils/Helpers';
import { CompetitionContext } from '../Context/CompetitionContext';

const validationSchema = Yup.object({
  competition_id: Yup.number()
    .typeError('مسابقه الزامی است')
    .required('مسابقه الزامی است'),
  coaches_id: Yup.number()
    .typeError('انتخاب مربی الزامی است')
    .required('انتخاب مربی الزامی است'),
});

const BestCoaches = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const context = useContext(CompetitionContext);
  const [formSubmitLoading, setFormSubmitLoaing] = useState(false);
  const [serverErrors, setServerErrors] = useState({});
  const { get, post } = useApi();
  const { error, success } = useToast();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getData = async () => {
      await getCoaches();
      await getCompetition();
    };
    getData();
  }, [id]);

  const getCoaches = async () => {
    setLoading(true);
    await get(
      `/competition/${id}/get-coaches`,
      (res) => {
        context.coaches = res.data;
      },
      (err) => {
        setLoading(false);
        error('دریافت اطلاعات با خطا مواجه شد.');
      },
    );
  };

  const getCompetition = async () => {
    setLoading(true);
    await get(
      `/competition/${id}`,
      (res) => {
        context.competition = res.data;
        setLoading(false);
      },
      (err) => {
        setLoading(false);
        error('دریافت اطلاعات با خطا مواجه شد.');
      },
    );
  };

  const submitForm = async (values, setSubmitingForm) => {
    setFormSubmitLoaing(true);
    await post(
      '/competition/best-coach',
      {
        competition_id: values.competition_id,
        coaches_id: values.coaches_id,
      },
      (res) => {
        success('عملیات با موفقیت ثبت شد.');
        setFormSubmitLoaing(false);
        navigate('/competition');
      },
      (err) => {
        setFormSubmitLoaing(false);
        if (err?.status === 422) {
          serverErrorHandler(err?.data?.errors, setServerErrors, serverErrors);
          error('لطفا خطاهای فرم را رفع کنید.');
        } else {
          error('عملیات به علت خطا انجام نشد.');
        }
      },
    );
  };

  return loading ? (
    <Loading />
  ) : (
    <Master>
      <TitleBar
        title='انتخاب مربی برتر'
        showBackBtn={true}
        showCreateBtn={false}
        showFilterBtn={false}
        backPath='/competition'
      />
      <Form
        initialValues={{
          competition_id: context?.competition?.id,
          competition_title: context?.competition?.title,
          coaches_id: context?.competition?.bestCompetitionCoaches,
        }}
        loading={formSubmitLoading}
        onSubmit={submitForm}
        validationSchema={validationSchema}
      >
        <div className='row'>
          <div className='col-12 col-md-6'>
            <div className='row'>
              <div className='col-12'>
                <Text
                  name='competition_title'
                  disabled={true}
                  title='مسابقه'
                  serverError={serverErrors.competition_title}
                />
              </div>
            </div>
          </div>
          <div className='col-12 col-md-6'>
            <div className='row'>
              <div className='col-12'>
                <MultiSelect
                  title='مربیان مسابقه'
                  defaultValue={context.competition?.bestCompetitionCoaches}
                  name='coaches_id'
                  getOptionLabel={(t) => t?.name + ' ' + t?.last_name}
                  getOptionValue={(t) => t?.id}
                  options={context.coaches}
                  serverError={serverErrors.coaches_id}
                />
              </div>
            </div>
          </div>
        </div>
      </Form>
    </Master>
  );
};

export default BestCoaches;
